import React from 'react';
import { products } from '../../data/products';
import Hero from '../../components/Hero';
import ProductCard from '../../components/ProductCard';

const Cameras = () => {
  const cameras = products.filter(product =>
    product.name.toLowerCase().includes('camera') ||
    product.name.toLowerCase().includes('supraveghere')
  );

  return (
    <>
      <Hero
        title="Camere de Supraveghere"
        subtitle="Sisteme de supraveghere video pentru siguranța ta"
        backgroundImageUrl="/img/hero-cat-cameras.jpg"
      />
      <section className="py-20 px-4 bg-gray-50">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {cameras.map((product, index) => (
              <ProductCard key={product.id} product={product} index={index} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Cameras;
